"use strict";
import { Button, Card, Loading, Tab } from "@alifd/next";
import Ansi from "ansi-to-react";
import classNames from "classnames";
import { Link } from "dva/router";
import React, { Component } from "react";
import { HiOutlineRefresh } from "react-icons/hi";
import {
  loadPipeline,
  loadPipelineRunBase,
  loadPipelineRunStatus,
  loadPipelineRunStepInputs,
  loadPipelineRunStepLogs,
  loadPipelineRunStepOutputs
} from "../../api/pipeline";
import Empty from "../../components/Empty";
import { If } from "../../components/If";
import PipelineGraph from "../../components/PipelineGraph";
import { Translation } from "../../components/Translation";
import { convertAny, timeDiff } from "../../utils/common";
import Header from "./components/Header";
import "./index.less";
class PipelineRunPage extends Component {
  constructor(props) {
    super(props);
    this.onGetPipeline = (match) => {
      const { projectName, pipelineName } = match ? match.params : this.props.match.params;
      loadPipeline({ projectName, pipelineName }).then((res) => {
        this.setState({ pipelineDetail: res });
      });
    };
    this.onGetRunBase = (match) => {
      const { projectName, pipelineName, runName } = match ? match.params : this.props.match.params;
      loadPipelineRunBase({ projectName, pipelineName, runName }).then((res) => {
        this.setState({ runBase: res });
      });
    };
    this.onGetStepLogs = () => {
      const { projectName, pipelineName, runName } = this.props.match.params;
      const { stepStatus } = this.state;
      if (stepStatus?.name) {
        this.setState({ logLoading: true });
        loadPipelineRunStepLogs({
          projectName,
          pipelineName,
          runName,
          stepName: stepStatus?.name
        }).then((res) => {
          const logLines = res && res.log ? res.log.split("\n") : [];
          this.setState({ logs: logLines });
        }).finally(() => {
          this.setState({ logLoading: false });
        });
      }
    };
    this.onGetRunStatus = (match) => {
      const { projectName, pipelineName, runName } = match && match.params ? match.params : this.props.match.params;
      this.setState({ loading: true });
      loadPipelineRunStatus({ projectName, pipelineName, runName }).then((res) => {
        if (res) {
          this.setState({ runStatus: res });
          if (res.status && ["terminated", "failed", "succeeded"].indexOf(res.status) == -1 && !this.loop && !this.disableLoop) {
            this.loop = true;
            setTimeout(() => {
              this.loop = false;
              this.onGetRunStatus();
            }, 5e3);
          }
        }
      }).finally(() => {
        this.setState({ loading: false });
      });
    };
    this.onGetStepOutput = () => {
      const { projectName, pipelineName, runName } = this.props.match.params;
      const { stepStatus } = this.state;
      if (stepStatus) {
        this.setState({ outputLoading: true });
        loadPipelineRunStepOutputs({
          projectName,
          pipelineName,
          runName,
          stepName: stepStatus?.name
        }).then((res) => {
          const outputs = res && Array.isArray(res.outputs) && res.outputs.length > 0 ? res.outputs[0] : void 0;
          this.setState({
            outputs
          });
        }).finally(() => {
          this.setState({ outputLoading: false });
        });
      }
    };
    this.onGetStepInput = () => {
      const { projectName, pipelineName, runName } = this.props.match.params;
      const { stepStatus } = this.state;
      if (stepStatus) {
        this.setState({ inputLoading: true });
        loadPipelineRunStepInputs({
          projectName,
          pipelineName,
          runName,
          stepName: stepStatus?.name
        }).then((res) => {
          const input = res && Array.isArray(res.inputs) && res.inputs.length > 0 ? res.inputs[0] : void 0;
          this.setState({
            inputs: input
          });
        }).finally(() => {
          this.setState({ inputLoading: false });
        });
      }
    };
    this.onStepClick = (step) => {
      this.setState({ showDetail: true, stepStatus: step }, () => {
        const { activeKey } = this.state;
        this.onTabChange(activeKey);
      });
    };
    this.onTabChange = (key) => {
      const { stepStatus } = this.state;
      this.setState({ activeKey: key });
      if (key == "outputs" && stepStatus) {
        this.onGetStepOutput();
      }
      if (key == "detail" && stepStatus) {
        this.onGetStepLogs();
      }
      if (key == "inputs" && stepStatus) {
        this.onGetStepInput();
      }
    };
    this.state = {
      loading: false,
      showDetail: false,
      activeKey: "detail"
    };
    this.loop = false;
    this.disableLoop = false;
  }
  componentWillUnmount() {
    this.disableLoop = true;
  }
  componentDidMount() {
    this.onGetPipeline(this.props.match);
    this.onGetRunBase(this.props.match);
    this.onGetRunStatus(this.props.match);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.location?.pathname != this.props.location?.pathname && nextProps.match) {
      this.onGetPipeline(nextProps.match);
      this.onGetRunBase(nextProps.match);
      this.onGetRunStatus(nextProps.match);
    }
  }
  render() {
    const {
      loading,
      runStatus,
      showDetail,
      logs,
      runBase,
      stepStatus,
      logLoading,
      pipelineDetail,
      inputLoading,
      outputLoading,
      inputs,
      outputs
    } = this.state;
    let addonName = "";
    let stepSpec;
    runBase?.spec.workflowSpec.steps.map((step) => {
      if (stepStatus && step.name == stepStatus.name) {
        addonName = step.properties?.addonName;
        stepSpec = step;
      }
      step.subSteps?.map((sub) => {
        if (stepStatus && sub.name == stepStatus.name) {
          addonName = sub.properties?.addonName;
          stepSpec = sub;
        }
      });
    });
    return /* @__PURE__ */ React.createElement("div", { className: "run-layout" }, /* @__PURE__ */ React.createElement(
      Header,
      {
        statusLoading: loading,
        runBase,
        runStatus,
        loadRunStatus: this.onGetRunStatus,
        pipeline: pipelineDetail
      }
    ), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "run-studio",
        onClick: () => {
          this.setState({ showDetail: false });
        }
      },
      /* @__PURE__ */ React.createElement("div", { className: classNames("studio") }, runStatus && /* @__PURE__ */ React.createElement(
        PipelineGraph,
        {
          name: `${runBase?.pipelineRunName}`,
          steps: runStatus.steps,
          zoom: 1,
          onNodeClick: this.onStepClick
        }
      )),
      /* @__PURE__ */ React.createElement(If, { condition: showDetail && stepStatus }, /* @__PURE__ */ React.createElement(
        Card,
        {
          title: "Step: " + stepStatus?.name || stepStatus?.id,
          className: classNames("detail"),
          contentHeight: "auto",
          onClick: (event) => {
            event.stopPropagation();
          }
        },
        /* @__PURE__ */ React.createElement(Tab, { animation: true, size: "medium", onChange: this.onTabChange }, /* @__PURE__ */ React.createElement(Tab.Item, { title: /* @__PURE__ */ React.createElement(Translation, null, "Detail"), key: "detail" }, /* @__PURE__ */ React.createElement("div", { className: "detail-page" }, /* @__PURE__ */ React.createElement("div", { className: "step-info padding16" }, stepStatus && /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Type:"), /* @__PURE__ */ React.createElement("td", null, stepStatus.type)), /* @__PURE__ */ React.createElement(If, { condition: addonName }, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Addon:"), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(Link, { to: `/addons/${addonName}` }, addonName), " (Click here to check the addon detail)"))), /* @__PURE__ */ React.createElement(If, { condition: stepSpec?.if }, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Condition:"), /* @__PURE__ */ React.createElement("td", null, stepSpec?.if))), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "First Execute Time:"), /* @__PURE__ */ React.createElement("td", null, stepStatus.firstExecuteTime)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Last Execute Time:"), /* @__PURE__ */ React.createElement("td", null, stepStatus.lastExecuteTime)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Duration:"), /* @__PURE__ */ React.createElement("td", null, timeDiff(stepStatus.firstExecuteTime, stepStatus.lastExecuteTime))), /* @__PURE__ */ React.createElement(If, { condition: stepSpec?.timeout }, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Timeout:"), /* @__PURE__ */ React.createElement("td", null, stepSpec?.timeout))), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Phase:"), /* @__PURE__ */ React.createElement("td", { className: "step-status-text-" + stepStatus.phase }, stepStatus.phase)), /* @__PURE__ */ React.createElement(If, { condition: stepStatus.message || stepStatus.reason }, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Message(Reason):"), /* @__PURE__ */ React.createElement("td", null, `${stepStatus.message || ""}`, stepStatus.reason && `(${stepStatus.reason})`))))), /* @__PURE__ */ React.createElement("div", { className: "step-log" }, /* @__PURE__ */ React.createElement("div", { className: "header" }, /* @__PURE__ */ React.createElement("div", null, "Step Logs"), /* @__PURE__ */ React.createElement(
          Button,
          {
            loading: logLoading,
            onClick: () => {
              this.onGetStepLogs();
            },
            style: { color: "#fff" },
            size: "small"
          },
          /* @__PURE__ */ React.createElement(HiOutlineRefresh, null)
        )), /* @__PURE__ */ React.createElement("div", { className: "log-content" }, logs?.map((line, i) => {
          return /* @__PURE__ */ React.createElement("div", { key: `log-${i}`, className: "logLine" }, /* @__PURE__ */ React.createElement("span", { className: "content" }, /* @__PURE__ */ React.createElement(Ansi, { linkify: true }, line)));
        }))))), /* @__PURE__ */ React.createElement(Tab.Item, { title: "Properties", key: "properties" }, /* @__PURE__ */ React.createElement("div", { className: "step-info padding16" }, /* @__PURE__ */ React.createElement("tbody", null, stepSpec && stepSpec.properties && Object.keys(stepSpec.properties).map((key) => {
          return /* @__PURE__ */ React.createElement("tr", { key }, /* @__PURE__ */ React.createElement("th", null, key, ":"), /* @__PURE__ */ React.createElement("td", null, stepSpec && stepSpec.properties && convertAny(stepSpec.properties[key])));
        })))), /* @__PURE__ */ React.createElement(Tab.Item, { title: "Outputs", key: "outputs" }, /* @__PURE__ */ React.createElement(If, { condition: !outputLoading && (!outputs || !outputs.values || outputs.values.length == 0) }, /* @__PURE__ */ React.createElement(Empty, { hideIcon: true, message: "There are no outputs." })), /* @__PURE__ */ React.createElement(Loading, { visible: outputLoading, style: { width: "100%" } }, /* @__PURE__ */ React.createElement("div", { className: "step-info padding16" }, outputs?.values?.map((value) => {
          return /* @__PURE__ */ React.createElement("tbody", { key: value.name }, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Name: "), /* @__PURE__ */ React.createElement("td", null, value.name)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Value: "), /* @__PURE__ */ React.createElement("td", null, value.value)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Value From"), /* @__PURE__ */ React.createElement("td", null, value.valueFrom || "-")));
        })))), /* @__PURE__ */ React.createElement(Tab.Item, { title: "Inputs", key: "inputs" }, /* @__PURE__ */ React.createElement(If, { condition: !inputLoading && (!inputs || !inputs?.values || inputs.values.length == 0) }, /* @__PURE__ */ React.createElement(Empty, { hideIcon: true, message: "There are no inputs." })), /* @__PURE__ */ React.createElement(Loading, { visible: inputLoading, style: { width: "100%" } }, /* @__PURE__ */ React.createElement("div", { className: "step-info padding16" }, /* @__PURE__ */ React.createElement("tbody", null, inputs?.values?.map((value) => {
          return /* @__PURE__ */ React.createElement("tbody", { key: value.fromStep + value.from }, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "From Step: "), /* @__PURE__ */ React.createElement("td", null, value.fromStep)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "From: "), /* @__PURE__ */ React.createElement("td", null, value.from)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Value: "), /* @__PURE__ */ React.createElement("td", null, value.value)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "ParameterKey"), /* @__PURE__ */ React.createElement("td", null, value.parameterKey || "-")));
        }))))))
      ))
    ));
  }
}
export default PipelineRunPage;
